<div class="prize-date-filter">
  <div class="section-header">
    <div class="section-title">
      <h4>Dates</h4>
    </div>
  </div>

  <div class="condition-rows" *ngIf="rowsForm">
    <div class="condition-row" *ngFor="let row of rows; let i = index" [formGroup]="row">
      <span *ngIf="i === 0" class="where-label">Where</span>
      <p-dropdown
        *ngIf="i > 0"
        class="and-or-dropdown"
        [options]="andOrOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="andOr"
        [autoDisplayFirst]="false"
        [style]="{ width: '100%' }"
      ></p-dropdown>

      <p-dropdown
        class="field-dropdown"
        [options]="fieldOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="field"
        [autoDisplayFirst]="false"
        [style]="{ width: '100%' }"
      ></p-dropdown>

      <span class="is-label">is</span>

      <p-dropdown
        class="operator-dropdown"
        [options]="operatorOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="operator"
        [autoDisplayFirst]="false"
        [style]="{ width: '100%' }"
      ></p-dropdown>

      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger remove-row-btn"
        pTooltip="Remove condition"
        tooltipPosition="top"
        (click)="removeCondition(i)"
      ></button>
    </div>
  </div>

  <button
    pButton
    pRipple
    type="button"
    label="Add Condition"
    icon="pi pi-plus"
    class="p-button-text p-button-sm add-condition-btn"
    (click)="addCondition()"
  ></button>
</div>
